module.exports = __webpack_public_path__ + "img/1440.bffc19c7.jpg";